<template>
  <div class="highlght">
    <div class="video_con">
      <div class="video_bg">
        <div class="isvideo">
          <iframe
            :src="vediolink"
            allow="accelerometer;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            width="100%"
            height="100%"
            frameborder="0"
          ></iframe>
        </div>
        <div class="istxt">
          <div
            class="txt_tit"
            :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
          >
            {{ $t("home." + video[0].title) }}
          </div>
          <div class="txt_con" v-html="$t('home.' + video[0].text)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["vediolink", "video"],
  computed: {
    ...mapState(["headType"]),
    
  },
};
</script>

<style lang="scss" scoped>
.video_con {
  width: 100%;
  // margin-top: 160px;
  .video_bg {
    width: 95%;
    margin-left: 5%;
    height: 605px;
    background: rgb(51, 139, 201);
    background: url("../../assets/Male/2_Links/video-bg.jpg");
    // position: relative;
    display: flex;
    object-fit: cover;
    object-position: unset;
    .isvideo {
      width: 70%;
      height: 600px;
      background: rgb(189, 186, 186);
      // position: absolute;
      // top: -10%;
      // left: -5%;
      margin: -50px 0 0 -50px;
      border-radius: 20px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    .istxt {
      height: 470px;
      width: 30%;
      background: rgb(255, 255, 255);
      padding: 30px;
      border-radius: 30px;
      margin: 25px;
      div {
        text-align: left;
      }
      .txt_tit {
        font-size: 23px;
        color: #5aa2d3;
        font-weight: 600;
        text-align: left;
        max-width: 200px;
      }
      .txt_con {
        margin-top: 15px;
        line-height: 30px;
        font-size: 17px;
        color: #2d3b51;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .video_con {
    .video_bg {
      flex-direction: column;
      height: auto;
      width: 100%;
      margin-left: 0;
      .isvideo {
        width: 100%;
        margin: 0;
        height: 280px;
        margin-top: -80px;
      }
      .istxt {
        width: 90%;
        margin-left: 5%;
        height: auto;
      }
    }
  }
}
</style>